import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { coercedDate } from '../../../utils/coerced-date';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Get the vehicle history of a mobile-based asset
 * @param id Asset ID
 * @param params Paged Collection Params
 * @returns A data object containing an array of vehicles
 */
export function getUsersVehicleHistory(
  this: unknown,
  id: string,
  params?: PagedCollectionParams
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          accountsEnvironment.resolve(this).usersVehicleHistoryUrl
        }/${encodeURIComponent(id)}${params ? `?${params.urlParams}` : ''}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        vehicles: z.array(
          z.object({
            vehicleId: z.number(),
            vehicleName: z.string(),
            vehicleDeviceId: z.string(),
            modifiedOn: coercedDate,
          })
        ),
        totalSize: z.number(),
      })
    )
  );
}
